module.exports = __webpack_public_path__ + "img/logo.f5dd56aa.jpg";